import React from 'react';
import { 
  FiShield, FiEyeOff, FiZap, FiClock, 
  FiGrid, FiLock, FiBarChart, FiGlobe 
} from 'react-icons/fi';

const features = [
  {
    icon: FiShield,
    title: 'Zero-Knowledge Architecture',
    description: 'We can\'t track you even if we wanted to. No IP logging, no cookies, no user tracking.',
    color: 'text-primary-600',
    bgColor: 'bg-primary-100',
  },
  {
    icon: FiEyeOff,
    title: 'Tracker Blocking',
    description: 'Automatically removes Google Analytics, Facebook Pixel, and 50+ other trackers from destination pages.',
    color: 'text-green-600',
    bgColor: 'bg-green-100',
  },
  {
    icon: FiZap,
    title: 'Lightning Fast',
    description: 'Global CDN ensures your links redirect in under 50ms from anywhere in the world.',
    color: 'text-yellow-600',
    bgColor: 'bg-yellow-100',
  },
  {
    icon: FiGrid,
    title: 'Custom QR Codes',
    description: 'Professional QR codes with custom colors, logos, and multiple download formats for Pro users.',
    color: 'text-purple-600',
    bgColor: 'bg-purple-100',
    badge: 'Pro',
  },
  {
    icon: FiClock,
    title: 'Auto-Expiring Links',
    description: 'Links that self-destruct after first click. Perfect for sharing passwords or sensitive information.',
    color: 'text-orange-600',
    bgColor: 'bg-orange-100',
  },
  {
    icon: FiLock,
    title: 'Password Protection',
    description: 'Optional password protection for sensitive links with end-to-end encryption.',
    color: 'text-red-600',
    bgColor: 'bg-red-100',
  },
  {
    icon: FiBarChart,
    title: 'Privacy-First Analytics',
    description: 'See aggregated click data without compromising visitor privacy.',
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-100',
  },
  {
    icon: FiGlobe,
    title: 'No Geographic Tracking',
    description: 'Country-level data only. We never store city or precise location data.',
    color: 'text-teal-600',
    bgColor: 'bg-teal-100',
  },
];

const Features: React.FC = () => {
  return (
    <div className="py-12">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Privacy Features That Actually Matter
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Unlike other URL shorteners that harvest your data, we built AnonLink with privacy as the foundation, not an afterthought.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <div
              key={index}
              className="card hover:shadow-lg transition-shadow duration-200"
            >
              <div className="flex items-start justify-between mb-4">
                <div className={`inline-flex p-3 rounded-lg ${feature.bgColor}`}>
                  <Icon className={`w-6 h-6 ${feature.color}`} />
                </div>
                {feature.badge && (
                  <span className="px-2 py-1 text-xs font-semibold text-purple-600 bg-purple-100 rounded-full">
                    {feature.badge}
                  </span>
                )}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600">
                {feature.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Features;